import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import { numberWithCommas } from 'helper';
import PropTypes from 'prop-types';
import StatusIcon from 'modules/common/components/StatusIcon';

// import CmsContext from '../../../context/CmsContext';

const TransactionInformation = ({ transactionInfo, taxpayer, module }) => {
  // const cmsContext = useContext(CmsContext);

  // const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const serialNo =
    _.get(
      transactionInfo,
      'included.module.attributes.serial_number_complete'
    ) || '--';

  const permitNo =
    _.get(transactionInfo, 'included.module.attributes.permit_number') || '--';

  const certificateNo =
    _.get(transactionInfo, 'included.module.attributes.certificate_number') ||
    '--';

  const violations = _.get(
    transactionInfo,
    'included.module.attributes.violations'
  );

  return (
    <>
      <div className="row d-flex  mb-1 p-3">
        {/* <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Valid ID to Present
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'attributes.valid_id_to_present') || '--'}
            </span>
          </div>
        </div> */}
        {/* <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              {`Is Resident of ${_.get(CMS_VARIABLES, 'LGU_NAME')}`}
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(
                transactionInfo,
                'included.taxPayer.attributes.is_resident'
              )
                ? 'YES'
                : 'NO'}
            </span>
          </div>
        </div> */}
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Payment Status
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'attributes.status') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Permit Type
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'attributes.permit_type') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Transaction Type
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'attributes.transaction_type') || '--'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-2 mr-2 cit-label">
              Status
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              <StatusIcon
                value={_.get(transactionInfo, 'attributes.transaction_status')}
              />
            </span>
          </div>
          {
            // temporary fix to remove print status on QUARTERLY and DELINQUENT tab, will refactor later
            ['NEW', 'RENEWAL', 'TAX CLEARANCE'].indexOf(
              _.get(transactionInfo, 'attributes.transaction_type')
            ) > -1 ? (
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Print Status
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  <StatusIcon
                    value={
                      _.get(
                        transactionInfo,
                        'included.module.attributes.status'
                      ) || '--'
                    }
                  />
                </span>
              </div>
            ) : (
              ''
            )
          }
        </div>
        {/* <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-2 mr-2 cit-label">
              Transmittal No.
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'attributes.bpls_batch_number') ||
                _.get(
                  transactionInfo,
                  'included.module.attributes.transmittal_no'
                ) ||
                '--'}
            </span>
          </div>
        </div> */}
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Transaction ID
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'attributes.txnid') || '--'}
            </span>
          </div>
        </div>
        {module === 'ovrs' && (
          <>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Original Amount:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {' '}
                  PHP{' '}
                  {numberWithCommas(
                    _.get(transactionInfo, 'attributes.original_amount', 0) ||
                      '--'
                  )}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Encoding Status
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(
                    transactionInfo,
                    'included.module.attributes.encoding_status'
                  )}
                </span>
              </div>
            </div>
          </>
        )}
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Reference Number Generated On
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {!_.isNil(_.get(transactionInfo, 'attributes.pending_at', '--'))
                ? _.get(transactionInfo, 'attributes.pending_at', '--')
                : '--'}
            </span>
          </div>
        </div>
        {module === 'ovrs' && (
          <>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Discount:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {' '}
                  PHP{' '}
                  {numberWithCommas(
                    _.get(transactionInfo, 'attributes.discount', 0) || '--'
                  )}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Penalty:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {' '}
                  PHP{' '}
                  {numberWithCommas(
                    _.get(transactionInfo, 'attributes.penalty', 0) || '--'
                  )}
                </span>
              </div>
            </div>
          </>
        )}
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Reference Number
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {!_.isNil(_.get(transactionInfo, 'attributes.refno', '--'))
                ? _.get(transactionInfo, 'attributes.refno', '--')
                : '--'}
            </span>
          </div>
        </div>
        <div className="col-6 mt-1">
          <div className="d-flex flex-column">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label">
                Payment Amount
              </label>
              <span className="cit-span">:</span>
              <span className="transaction-text p-0">
                ₱{' '}
                {numberWithCommas(
                  _.get(transactionInfo, 'attributes.amount', 0) || '--'
                )}
              </span>
            </div>
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label">
                Discount Amount
              </label>
              <span className="cit-span">:</span>
              <span className="transaction-text p-0">
                ₱{' '}
                {numberWithCommas(
                  _.get(transactionInfo, 'attributes.discount', 0) || '--'
                )}
              </span>
            </div>
          </div>
        </div>
        {module === 'psa' ? (
          <div className="col-6 mt-1">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label">
                O.R. Number
              </label>
              <span className="cit-span">:</span>
              <span className="transaction-text p-0">
                {_.get(transactionInfo, 'attributes.or_number', '--')}
              </span>
            </div>
          </div>
        ) : ''}
        {/* <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Is Posted:
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              {_.get(transactionInfo, 'included.taxPayer.attributes.is_posted')
                ? 'YES'
                : 'NO'}
            </span>
          </div>
        </div> */}
        {module === 'nov'
          ? violations.map((violation) => {
              return (
                <div className="col-6 mt-1">
                  <div className="cit-inner">
                    <label className="font-weight-bold mb-0 mr-2 cit-label">
                      Violation:
                    </label>
                    <span className="cit-span">:</span>
                    <span className="transaction-text p-0">
                      {violation.violation_name}
                    </span>
                  </div>
                </div>
              );
            })
          : ''}

        {module === 'cdl' && (
          <div className="col-6 mt-1">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label">
                Serial Number:
              </label>
              <span className="cit-span">:</span>
              <span className="transaction-text p-0">{serialNo}</span>
            </div>
          </div>
        )}
        {module === 'ohp' && (
          <>
            <div className="col-12">
              <hr className="cit-hr" />
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Permit Number:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{permitNo}</span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Certificate Number:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{certificateNo}</span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Appointment Date
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {' '}
                  {_.get(taxpayer, 'appointment_date', '')
                    ? `${moment(
                        _.get(
                          transactionInfo,
                          'included.module.attributes.appointment_date'
                        )
                      ).format('LL')} ${_.get(taxpayer, 'appointment_period')}`
                    : '--'}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Serial Number:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{serialNo}</span>
              </div>
            </div>
          </>
        )}
        {module === 'pc' && (
          <>
            <div className="col-12">
              <hr className="cit-hr" />
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Permit Number:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{permitNo}</span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Certificate Number:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{certificateNo}</span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Appointment Date
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {' '}
                  {_.get(taxpayer, 'appointment_date', '')
                    ? `${moment(
                        _.get(
                          transactionInfo,
                          'included.module.attributes.appointment_date'
                        )
                      ).format('LL')} ${_.get(taxpayer, 'appointment_period')}`
                    : '--'}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Serial Number:
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{serialNo}</span>
              </div>
            </div>
          </>
        )}
        <div className="col-12">
          <hr className="cit-hr" />
        </div>
        {_.get(transactionInfo, 'attributes.printed_by') && (
          <>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Printed By
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {' '}
                  {_.get(transactionInfo, 'attributes.printed_by_full_name') ||
                    '--'}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Printed Date
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.printed_at')
                    ? moment(
                        _.get(transactionInfo, 'attributes.printed_at')
                      ).format('MM/DD/YYYY HH:mm:ss')
                    : `--`}
                </span>
              </div>
            </div>
          </>
        )}
        {_.get(transactionInfo, 'attributes.received_by') && (
          <>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Issued By
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.received_by_full_name') ||
                    '--'}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Issued Date
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.received_at')
                    ? moment(
                        _.get(transactionInfo, 'attributes.received_at')
                      ).format('MM/DD/YYYY HH:mm:ss')
                    : `--`}
                </span>
              </div>
            </div>
          </>
        )}
        {_.get(transactionInfo, 'attributes.reject_by') && (
          <>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Rejected By
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.reject_by_full_name') ||
                    '--'}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Rejected Date
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.reject_at')
                    ? moment(
                        _.get(transactionInfo, 'attributes.reject_at')
                      ).format('MM/DD/YYYY HH:mm:ss')
                    : `--`}
                </span>
              </div>
            </div>
          </>
        )}
        {_.get(transactionInfo, 'attributes.approve_by') && (
          <>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Approved By
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.approve_by_full_name') ||
                    '--'}
                </span>
              </div>
            </div>
            <div className="col-6 mt-1">
              <div className="cit-inner">
                <label className="font-weight-bold mb-0 mr-2 cit-label">
                  Approved Date
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">
                  {_.get(transactionInfo, 'attributes.approve_at')
                    ? moment(
                        _.get(transactionInfo, 'attributes.approve_at')
                      ).format('MM/DD/YYYY HH:mm:ss')
                    : `--`}
                </span>
              </div>
            </div>
            {_.get(transactionInfo, 'attributes.module_type') === 'T_BPLS' ? (
              ''
            ) : (
              <div className="col-6 mt-1">
                <div className="cit-inner">
                  <label className="font-weight-bold mb-0 mr-2 cit-label">
                    Delivery Option
                  </label>
                  <span className="cit-span">:</span>
                  <span className="transaction-text p-0">
                    {_.get(transactionInfo, 'attributes.delivery_location') || 0
                      ? 'FOR DELIVERY'
                      : 'FOR PICKUP'}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
        <div className="col-6 mt-1">
          <div className="cit-inner">
            <label className="font-weight-bold mb-0 mr-2 cit-label">
              Remarks
            </label>
            <span className="cit-span">:</span>
            <span className="transaction-text p-0">
              <pre>
                {!_.isNil(_.get(transactionInfo, 'attributes.remarks', '--'))
                  ? _.get(transactionInfo, 'attributes.remarks', '--')
                  : '--'}
              </pre>
            </span>
          </div>
        </div>
        {_.get(
          transactionInfo,
          'included.module.attributes.reject_remarks'
        ) && (
          <div className="col-6 mt-1">
            <div className="cit-inner">
              <label className="font-weight-bold mb-0 mr-2 cit-label">
                Reject Remarks
              </label>
              <span className="cit-span">:</span>
              <span className="transaction-text p-0">
                <pre>
                  {_.get(
                    transactionInfo,
                    'included.module.attributes.reject_remarks'
                  )}
                </pre>
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

TransactionInformation.defaultProps = {
  taxpayer: {},
};

TransactionInformation.propTypes = {
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object),
  module: PropTypes.string.isRequired,
};

export default TransactionInformation;
